<template lang="pug">
    div.webOnlyNotice
        title-component(:title="$t('payments.webOnly.title')" type="h2")
        div.mt-3.webOnlyMessage {{ $t('payments.webOnly.message') }}
</template>

<script>
    import Title from '~components/Title';

    // Shown on Android in place of any subscription purchase / payment UI.
    // Google Play's Payments policy forbids taking payment for digital
    // services through anything but Play Billing, and also forbids linking
    // out to an external checkout — so this is plain text only (no tappable
    // link to the website).
    export default {
        components: {
            TitleComponent: Title
        }
    };
</script>

<style lang="stylus" scoped>
    .webOnlyMessage
        font-size: 15px
        line-height: 1.5
</style>
